export default __webpack_public_path__ + "static/media/files.99cac632.svg";